<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>添加新闻</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 添加新闻 -->
    <el-form ref="form" :model="form" label-width="80px" style="margin-top: 20px;">
      <el-form-item label="标题" prop="title">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form :inline="true" class="demo-form-inline" style="margin-left: 10px;">
        <el-form-item label="新闻分类" prop="type">
            <el-select v-model="form.type" placeholder="请选择分类">
              <el-option v-for="item in form.newsoption" :key="index" :label="item" :value="item"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="置顶" prop="top">
          <el-switch v-model="form.top" active-value="1" inactive-value="0"></el-switch>
        </el-form-item>
        <el-form-item label="显示" prop="is_show">
          <el-switch v-model="form.is_show" active-value="1" inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <el-form-item label="封面图">
        <el-upload
          class="avatar-uploader"
          action="/api/system/uploadImg"
          :headers="upheader"
          :is_show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="作者">
          <el-input v-model="form.author" style="width: 200px;"></el-input>
        </el-form-item>
      <el-form-item label="描述" prop="describe">
        <el-input type="textarea" v-model="form.describe"></el-input>
      </el-form-item>
      <el-form-item label="内容">
        <editor ref="childs" @callFather="getcontent"></editor>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保 存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import editor from '../../components/wangEditor.vue';
  import { addNews,updateNews,getArticle,newsType } from '../../api/baseset';
  export default {
      data() {
        return {
          loading: false, //是显示加载
          form: {
            newsoption: [],
            type: '',
            author: '信息中心',
            describe: '',
            imageUrl: '',
            uploadurl: '',
            top: '0',
            is_show: '1'
          },
          imageUrl: '',
          upheader: {
            token: localStorage.getItem('logintoken')
          }
        }
      },
      components: {
        editor
      },
      created() {
        newsType().then(res => {
          this.form.newsoption = res.data
          this.form.type = res.data[0]
        })
        let id = this.$route.params.id;
        if(id != undefined && id != 'undefined'){
          let data = {id:id};
          this.loading = true;
          getArticle(data).then(res => {
            if(res.code == 0){
              this.form = res.data;
              this.imageUrl = res.data.uploadurl;
              this.$refs.childs.editcontent(res.data.content);
            }
          })
        }
      },
      methods: {
        onSubmit() {
          this.$refs.childs.setcontent()
          this.loading = true
          let id = this.$route.params.id;
          if(id != undefined && id != 'undefined'){
            this.form.id = id;
          }
          addNews(this.form).then(res => {
            this.loading = false
            if(res.code == 0){
              this.$message({
                type: 'success',
                message: res.msg
              })
              let id = this.$route.params.id;
              if(!id || id == undefined || id == 'undefined'){
                this.resetForm('form')
              }
            }else{
              this.$message.error(res.msg);
            }
          })

        },
        getcontent(content) {
          this.form.content = content;
        },
        handleAvatarSuccess(res, file) {
          this.form.uploadurl = res.data;
          this.imageUrl = URL.createObjectURL(file.raw);
        },
        beforeAvatarUpload(file) {
          const imgarr = ['image/jpeg','image/png','image/jpg','image/gif'];
          const isImg = imgarr.indexOf(file.type) !== -1;
          const isLt2M = file.size / 1024 / 1024 < 2;
          if (!isImg) {
            this.$message.error('上传文件格式不正确，请上传图片！');
          }
          if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 2MB!');
          }
          return isImg && isLt2M;
        },
        resetForm(formName) {
          this.$refs[formName].resetFields();
          this.uploadurl = '';
          this.imageUrl = '';
          this.$refs.childs.editcontent('');
        }
      }
    }
</script>

<style>
  .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
      border-color: #409EFF;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 178px;
      height: 178px;
      line-height: 178px;
      text-align: center;
    }
    .avatar {
      width: 178px;
      height: 178px;
      display: block;
    }
</style>



// WEBPACK FOOTER //
// src/views/news/article.vue